var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:`qrCodeCanvas${_vm.num}`,class:`qrCode${_vm.num}`})
}
var staticRenderFns = []

export { render, staticRenderFns }